<div class="location-card" (click)="onViewLocationDetails()">
  <!-- Location Image -->
  <div class="location-image">
    <img 
      [src]="location.photo || '/default-location-img.jpg'" 
      alt="{{location.practiceName}}" 
      class="location-img"
      [style.object-position]="location.photo ? 'center' : '90%'">
  </div>

  <!-- Location Content -->
  <div class="location-content">
    <!-- Location Name -->
    <div class="location-name">
      <div *ngFor="let line of getLocationNameLines()">{{ line }}</div>
    </div>

    <!-- Address -->
    <div class="location-address">
      <svg style="padding-top: 2px;" xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
        <ellipse cx="2.72048" cy="2.5" rx="2.72048" ry="2.5" fill="#959595"/>
        <line x1="2.67639" y1="4" x2="2.67639" y2="9" stroke="#959595"/>
      </svg>
      <div class="address-text">
        <div>{{location.address1}}</div>
        <div *ngIf="location.address2">{{location.address2}}</div>
        <div>{{location.city}}, {{location.state}} {{location.zipCode}}</div>
      </div>
    </div>

    <!-- Phone -->
    <div *ngIf="hasPhone()" class="location-phone">
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M6.74549 8.25004C5.16275 8.24806 3.64543 7.63899 2.52626 6.55639C1.40709 5.4738 0.777442 4.00606 0.775391 2.47504C0.775391 2.01754 0.963271 1.57878 1.2977 1.25528C1.63213 0.931783 2.08571 0.750043 2.55867 0.750043C2.65882 0.749305 2.7588 0.758097 2.85717 0.776293C2.95227 0.789906 3.04576 0.812514 3.13629 0.843793C3.19997 0.865404 3.25671 0.902718 3.3009 0.952045C3.3451 1.00137 3.37521 1.061 3.38828 1.12504L3.91939 3.37504C3.9337 3.43612 3.93198 3.49969 3.91437 3.55995C3.89676 3.62021 3.86384 3.67525 3.81859 3.72004C3.76819 3.77254 3.76432 3.77629 3.28749 4.01629C3.66934 4.82661 4.33931 5.47735 5.17543 5.85004C5.42742 5.38504 5.43129 5.38129 5.48557 5.33254C5.53187 5.28878 5.58877 5.25692 5.65107 5.23989C5.71337 5.22286 5.77909 5.2212 5.84222 5.23504L8.16824 5.74879C8.23232 5.76318 8.29157 5.7931 8.3404 5.83574C8.38923 5.87838 8.42604 5.93234 8.44736 5.99254C8.48008 6.08155 8.50472 6.17315 8.52102 6.26629C8.53662 6.36054 8.5444 6.45584 8.54428 6.55129C8.53713 7.00684 8.34397 7.44114 8.00696 7.75941C7.66995 8.07768 7.21646 8.25406 6.74549 8.25004V8.25004Z" fill="#888888"/>
      </svg>
      <span class="phone-text" (click)="onCallPhone()">{{location.phone}}</span>
    </div>

    <!-- Distance & View Details -->
    <div class="location-footer">
      <div>
        <div *ngIf="hasDirections()" class="get-directions">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M5.25 2.33337L1.75 4.08337V11.6667L5.25 9.91671M5.25 2.33337V9.91671M5.25 2.33337L8.75 4.08337M5.25 9.91671L8.75 11.6667M8.75 11.6667L12.25 10.5V2.91671L8.75 4.08337M8.75 11.6667V4.08337" stroke="#959595" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="directions-text" (click)="onGetDirections()">{{getDirectionsLabel}}</span>
        </div>
        <div *ngIf="hasDistance()" class="location-distance">
          <mat-icon class="distance-icon">near_me</mat-icon>
          <span>{{getDistanceText()}}</span>
        </div>
        <div *ngIf="!hasDistance()" class="location-distance">
          <span>{{getDistanceText()}}</span>
        </div>
      </div>
      <div *ngIf="canViewDetails" class="view-details-button" (click)="onViewLocationDetails()"> {{viewDetailsBtnText}}</div>
    </div>
  </div>
</div>
